module.exports = __webpack_public_path__ + "assets/img/1761589512664_.pic_hd.052691c9.jpg";